import React from 'react';

interface NumberInputWithLabelProps {
    value: string | number;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    min?: string | number;
    max?: string | number;
    placeholder?: string;
    className?: string;
    title?: string;
}

//'제외'라는 고정 텍스트 가진 숫자 인풋 컴포넌트
const NumberInputWithLabel: React.FC<NumberInputWithLabelProps> = ({
                                                                       value,
                                                                       onChange,
                                                                       min,
                                                                       max,
                                                                       placeholder,
                                                                       className,
                                                                       title
                                                                   }) => {
    // 숫자로 변환하여 음수인지 확인
    const isNegative = !isNaN(Number(value)) && Number(value) < 0;

    return (
        <div className="flex items-center gap-1">
            <input
                type="number"
                min={min}
                max={max}
                placeholder={placeholder}
                value={value === 0 ? '' : value}
                onChange={onChange}
                className={className}
                title={title}
            />
            {/*음수인 경우에만 '제외' 출력*/}
            {isNegative && (
                <span className="text-sm text-red-600 whitespace-nowrap">제외</span>
            )}
        </div>
    );
};

export default NumberInputWithLabel;